import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import PersonIcon from '@mui/icons-material/Person';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useAuth } from '../contexts/AuthContext';
import { t } from '../utils/localization/localization';

export default function UnauthorizedPage() {
  const { userRole, ROLES } = useAuth();

  const getRoleName = (role) => {
    switch(role) {
      case ROLES.ADMIN:
        return t('common.admin');
      case ROLES.MANAGER:
        return t('common.manager');
      case ROLES.USER:
        return t('common.user');
      default:
        return t('common.unknown');
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <SecurityIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h4" gutterBottom>
              {t('errors.accessDenied')}
            </Typography>
            <Typography variant="body1">
              {t('errors.noPermission')} <strong>{getRoleName(userRole)}</strong>.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>
            {t('common.permissions')}
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                primary={t('common.user')}
                secondary={t('errors.userPermissions')}
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <SupervisorAccountIcon />
              </ListItemIcon>
              <ListItemText
                primary={t('common.manager')}
                secondary={t('errors.managerPermissions')}
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText
                primary={t('common.admin')}
                secondary={t('errors.adminPermissions')}
              />
            </ListItem>
          </List>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Button
              component={Link}
              to="/"
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              {t('common.dashboard')}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
